import { type RouteRecordRaw } from 'vue-router'

import { authRoutes } from './routes/account/auth'
import { accountRoutes, accountRoutesNew } from './routes/account/account'
import { invitationRoutes } from './routes/account/invitations'
import adminRoutes from './routes/admin/admin'
import { receiverRoutes } from './routes/receiver/receiver'
import { shopRoutes } from './routes/shop/shop'
import { integrationsRoutes } from './routes/integrations/integrations'
import { customerRoutes } from './routes/customer/customer'

const routes: RouteRecordRaw[] = [
  // HOME
  {
    path: '/',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'overview',
        component: () => import('pages/receiver/overview/OverviewPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'files',
        name: 'overview-files',
        component: () => import('pages/receiver/overview/AllFiles.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      // Bulk Import in progress
      {
        path: 'bulk-import/:importId',
        name: 'bulk-import-in-progress',
        component: () =>
          import('pages/receiver/bulkImport/BulkImportInProgress.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/transformations',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () =>
          import('pages/receiver/transformations/TransformationOnboarding.vue'),
        name: 'transformations',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/bin',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: ':type',
        component: () => import('pages/receiver/bin/BinPage.vue'),
        name: 'bin-page',
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  // AUTH
  ...authRoutes,
  // ACCOUNT
  ...accountRoutes,
  ...accountRoutesNew,
  // SHOP
  ...shopRoutes,
  // INVITATION
  ...invitationRoutes,
  // ADMIN
  ...adminRoutes,
  // RECEIVER
  ...receiverRoutes,
  // INTEGRATIONS
  ...integrationsRoutes,
  // CUSTOMERS
  ...customerRoutes,

  // DOCUMENTATION
  {
    path: '/documentation',
    component: () => import('layouts/receiver/MainLayout.vue'),
    redirect: '/documentation/functions',
    children: [
      {
        path: 'functions',
        name: 'functions-documentation',
        component: () =>
          import('pages/receiver/documentation/FunctionsDoc.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  // SENDER RECOVERY
  {
    path: '/send/recovery',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/receiver/send/RecoveryPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  // WAIT PAGE
  {
    path: '/wait/:type',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/common/wait/WaitPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },

  // ERROR
  {
    path: '/error',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/common/errors/GeneralErrorPage.vue'),
        meta: {
          requiresAuth: false,
        },
      },
    ],
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('layouts/receiver/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/common/errors/ErrorNotFound.vue'),
      },
    ],
  },
]

export default routes
